import type {CSS} from '@pinecast/styles';
import styled from '@pinecast/styles';

// The same treatment as `ScreenReaderOnly`, for callers that need it on an
// element the component can't render (a `table`, say).
export const screenReaderOnlyStyles: CSS = {
  border: 0,
  clipPath: 'inset(50%)',
  height: 1,
  margin: -1,
  overflow: 'hidden',
  padding: 0,
  position: 'absolute',
  whiteSpace: 'nowrap',
  width: 1,
};

// Visually hidden, but still announced. Use this to give assistive technology a
// spelled-out version of content that is abbreviated or symbolic on screen
// (e.g. "4 / 5" next to a star, or a flag emoji), pairing it with `aria-hidden`
// on the visual counterpart.
//
// `clip-path` rather than `display: none`/`visibility: hidden`, both of which
// remove the element from the accessibility tree entirely.
const ScreenReaderOnly = styled('span', screenReaderOnlyStyles);

export default ScreenReaderOnly;
